export const UpdateCustomRoleApi = Symbol.for('UpdateCustomRoleApi');
